import { refreshScrollTrigger } from './scroll-trigger.js';

export function initFaq() {
  const questionItems = document.querySelectorAll('.faq .item__question-item');

  if (!questionItems.length) {
    return;
  }

  questionItems.forEach((questionItem) => {
    questionItem.addEventListener('click', () => {
      const item = questionItem.closest('.item');

      if (!item) {
        return;
      }

      item.classList.toggle('is-open');

      const answer = item.querySelector('.item__answer-item');

      if (!answer) {
        return;
      }

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'max-height') {
          return;
        }

        answer.removeEventListener('transitionend', onTransitionEnd);
        refreshScrollTrigger();
      };

      answer.addEventListener('transitionend', onTransitionEnd);
    });
  });
}
